module.exports = __webpack_public_path__ + "assets/img/shop_btn1.df60466b.png";